import * as Sentry from '@sentry/react';

export type TSentryMarkedError = {
  __sentryCaptured?: boolean;
  __sentryCapturedBy?: string;
};

export function isSentryInitialized(): boolean {
  try {
    return !!(Sentry as any)?.getCurrentHub?.()?.getClient?.();
  } catch {
    return false;
  }
}

export function isSentryCaptured(error: unknown): boolean {
  return !!(error as TSentryMarkedError | null | undefined)?.__sentryCaptured;
}

export function markSentryCaptured(error: unknown, by: string): void {
  if (!error || (typeof error !== 'object' && typeof error !== 'function')) return;
  const e = error as TSentryMarkedError;
  e.__sentryCaptured = true;
  e.__sentryCapturedBy = by;
}

export function normalizeError(e: unknown): Error {
  if (e instanceof Error) return e;
  try {
    return new Error(typeof e === 'string' ? e : String(e));
  } catch {
    return new Error('Unknown error');
  }
}

